import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const QUARTILE_VIDEO_REPORT_ID = `quartile${VIDEO_CAMPAIGN_SUFFIX}`;
